"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var layout_models_1 = require("../../../../layout-models");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var lodash_1 = require("lodash");
var ExportFormMetadataComponent = /** @class */ (function () {
    function ExportFormMetadataComponent() {
    }
    ExportFormMetadataComponent.prototype.description = function (state) {
        if (state && state['notes']) {
            return state['notes'];
        }
        else {
            return 'N/A';
        }
    };
    ExportFormMetadataComponent.prototype.textFileDownloadUrl = function (data) {
        var blob = new Blob([data], { type: 'application/octet-stream' });
        return window.URL.createObjectURL(blob);
    };
    ExportFormMetadataComponent.prototype.extractFields = function (fieldObject) {
        if (Object.keys(fieldObject).length > 0) {
            if (fieldObject['field']) {
                return "{\n                     \t\t\t\t   \tfield system name: " + fieldObject['field'].metaFieldId.systemName + ",\n                     \t\t\t\t   \tfield display name: " + (lodash_1.isEmpty(fieldObject['field']['displayNameMultilingual']
                    ._values)
                    ? 'N/A'
                    : fieldObject['field']['displayNameMultilingual']._values.get(this.currentLanguage.getId())) + ",\n                     \t\t\t\t   \tcompound category system name: " + (lodash_1.isNil(fieldObject['field'].compoundCategorySystemName)
                    ? 'N/A'
                    : fieldObject['field'].compoundCategorySystemName) + ",\n                     \t\t\t\t   \tcategory ID: " + fieldObject['field'].metaFieldId.metaCategoryId
                    .systemName + ",\n                     \t\t\t\t   \tmax length: " + (lodash_1.isNil(fieldObject['field'].maxLength)
                    ? 'N/A'
                    : fieldObject['field'].maxLength) + "\n                     }";
            }
            else {
                var displayNamesComaSeparated = '';
                for (var _i = 0, _a = Object.keys(fieldObject); _i < _a.length; _i++) {
                    var key = _a[_i];
                    displayNamesComaSeparated += "{\n                     \t\t\t\t   \tfield system name: " + fieldObject[key].metaFieldId.systemName + ",\n                     \t\t\t\t   \tfield display name: " + (lodash_1.isEmpty(fieldObject[key]['displayNameMultilingual']._values)
                        ? 'N/A'
                        : fieldObject[key]['displayNameMultilingual']._values.get(this.currentLanguage.getId())) + ",\n                     \t\t\t\t   \tcompound category system name: " + (lodash_1.isNil(fieldObject[key].compoundCategorySystemName)
                        ? 'N/A'
                        : fieldObject[key].compoundCategorySystemName) + ",\n                     \t\t\t\t   \tcategory ID: " + fieldObject[key].metaFieldId.metaCategoryId.systemName + ",\n                     \t\t\t\t   \tmax length: " + (lodash_1.isNil(fieldObject[key].maxLength)
                        ? 'N/A'
                        : fieldObject[key].maxLength) + "\n                     }";
                }
                return displayNamesComaSeparated;
            }
        }
        else {
            return 'N/A';
        }
    };
    ExportFormMetadataComponent.prototype.exportAction = function () {
        var _this = this;
        var formExportData = this.initialExportText();
        this.layoutContent.layoutRows.forEach(function (row) {
            row.cards.forEach(function (card) {
                var formCardModel = card;
                formCardModel.formCardRows.forEach(function (formCardRows) {
                    formCardRows.cells.forEach(function (formCardCellModel) {
                        var fieldsDescriptions = "Participating field(s): " + _this.extractFields(formCardCellModel.controller.fields);
                        var controlLineString = "\n\t\t\t\t\t\t   Control name: " + _this.title(formCardCellModel.controller) + "\n                                                   Control description: " + _this.description(formCardCellModel
                            .controller.state) + "\n                                                   " + fieldsDescriptions + "\n\n                                                   ---------------------------------------------------\n\n                                                   ";
                        formExportData = formExportData + controlLineString;
                    });
                });
            });
        });
        var link = document.createElement('a');
        link.href = this.textFileDownloadUrl(formExportData + '\n ]');
        link.download = "Form Title : " + this.formName;
        link.click();
    };
    ExportFormMetadataComponent.prototype.title = function (controllerModel) {
        if (controllerModel.title) {
            if (controllerModel.title.titleMessageSource === 'custom') {
                return lodash_1.isNil(controllerModel.title.customText[this.currentLanguage.getId()])
                    ? controllerModel.meta.name
                    : controllerModel.title.customText[this.currentLanguage.getId()];
            }
            else if (controllerModel.title.titleMessageSource === 'display_name') {
                return lodash_1.isNil(controllerModel.singleFieldMultilingualDisplayName[this.currentLanguage.getId()])
                    ? controllerModel.meta.name
                    : controllerModel.singleFieldMultilingualDisplayName[this.currentLanguage.getId()];
            }
            else if (controllerModel.title.titleMessageSource === 'msg') {
                return lodash_1.isNil(controllerModel.fieldMessageIdIfSingle())
                    ? controllerModel.meta.name
                    : controllerModel.fieldMessageIdIfSingle();
            }
        }
        return lodash_1.isNil(controllerModel.singleFieldMultilingualDisplayName[this.currentLanguage.getId()])
            ? 'N/A'
            : controllerModel.singleFieldMultilingualDisplayName[this.currentLanguage.getId()];
    };
    ExportFormMetadataComponent.prototype.initialExportText = function () {
        return "Form Title : " + this.formName + "\n         Related Category : " + this.categoryName + "\n\n         Controls: [                               ";
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", layout_models_1.DesignerContentLayoutModel)
    ], ExportFormMetadataComponent.prototype, "layoutContent", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ExportFormMetadataComponent.prototype, "formName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ExportFormMetadataComponent.prototype, "categoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_crosscutting_concepts_frontend_1.Language)
    ], ExportFormMetadataComponent.prototype, "currentLanguage", void 0);
    ExportFormMetadataComponent = __decorate([
        core_1.Component({
            selector: 'export-form-metadata',
            template: require('./export-form-metadata.component.html'),
        })
    ], ExportFormMetadataComponent);
    return ExportFormMetadataComponent;
}());
exports.ExportFormMetadataComponent = ExportFormMetadataComponent;
//# sourceMappingURL=export-form-metadata.component.js.map